import { render, staticRenderFns } from "./AppointmentSidebar.vue?vue&type=template&id=1764b891&"
import script from "./AppointmentSidebar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentSidebar.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1764b891')) {
      api.createRecord('1764b891', component.options)
    } else {
      api.reload('1764b891', component.options)
    }
    module.hot.accept("./AppointmentSidebar.vue?vue&type=template&id=1764b891&", function () {
      api.rerender('1764b891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentSidebar.vue"
export default component.exports